import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import './PricingTeaser.css';

const PricingTeaser = () => {
  return (
    <section className="pt-section" id="pricing">
      <div className="pt-container">
        <p className="pt-eyebrow">Pricing</p>
        <h2 className="pt-title">Simple, Transparent Pricing</h2>
        <p className="pt-subtitle">
          Starting at <strong>$499/mo</strong> with unlimited AI calls, custom voice agents,
          and full CRM integration. No hidden fees.
        </p>
        <Link to="/pricing" className="btn-primary pt-cta">
          View Plans <ArrowRight size={18} />
        </Link>
        <p className="pt-footnote">Free trial available &middot; No credit card required</p>
      </div>
    </section>
  );
};

export default PricingTeaser;
